export function getDecodedSign(symbol?: string): string {
  const decodedSign =
    symbol?.replace(/&#(\d+);/g, function (_, dec) {
      return String.fromCharCode(dec);
    }) ?? '$';
  return decodedSign.includes('$') ? '$' : decodedSign;
}
